import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { paymentState } from "@/js/lists.ts";
export default {
  name: "payment-badge",
  props: {
    state: String,
    date: String,
    reference: String,
    suffix: String,
    textStyle: String,
    small: Boolean,
    list: Boolean,
    tooltip: String
  },
  data: function data() {
    return {
      paymentState: paymentState
    };
  },
  computed: {
    isStateShown: function isStateShown() {
      return !this.list && this.state !== paymentState.DEFERRED;
    }
  },
  methods: {
    stateStyleClass: function stateStyleClass() {
      return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, paymentState.SUCCEEDED, "success"), paymentState.PROCESSING, "neutral"), paymentState.ACKNOWLEDGED, !this.list ? "neutral" : "warning"), paymentState.DEFERRED, "neutral"), paymentState.FAILED, "danger");
    }
  }
};